import React, { useRef, useEffect, useState } from 'react'
import { withGoogleMap, GoogleMap, withScriptjs, OverlayView } from 'react-google-maps'
import { useTranslation } from 'react-i18next'
import {Tooltip as ReactTooltip} from 'react-tooltip'
import ReactDOMServer from 'react-dom/server'

import styles from './styles.module.scss'

import config from '../../../config'
import { formatLatestScan } from '../utils'

import { LocationIcon } from '../Icons'

const getCurrentCenter = (selectedAsset) => {
  if (selectedAsset && selectedAsset.latest_scan) {
    const [lat, lng] = selectedAsset.latest_scan.coordinates.split(',')
    return {
      lat: lat*1,
      lng: lng*1,
    }
  }
  return { lat: 55.1694, lng: 23.8813 } // default center
}

const Map = withScriptjs(withGoogleMap((props) => {
  return (
    <GoogleMap
      options={{
        // zoomControl: false,
        // mapTypeControl: false,
        // fullscreenControl: false,
        // streetViewControl: false,
        // scaleControl: false,
        // rotateControl: false,
        // keyboardShortcuts: true,
        // draggable: false,
        // scrollwheel: false,
        // disableDoubleClickZoom: true,
        // gestureHandling: 'none',
        // disableDefaultUI: true,
        styles: [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }],
          }
        ],
      }}
      {...props}
      />
  )
}))

const AssetMap = ({ selectedAsset, assets }) => {
  const containerRef = useRef(null)
  const { i18n, t } = useTranslation()

  const [height, setHeight] = useState(400)

  const currentCenter = getCurrentCenter(selectedAsset)

  useEffect(() => {
    setHeight(containerRef.current.clientHeight)
  }, [])

  const renderTooltipContent = (asset) => {
    return (
      ReactDOMServer.renderToString(
        <div className={styles.tooltipContent}>
          <div className={styles.title}>{asset.name}</div>
          <div className={styles.row}>
            <div className={styles.label}>{t('Last scan:')}</div>
            <div className={styles.value}>{formatLatestScan(asset.latest_scan)}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>{t('Scanned by:')}</div>
            <div className={styles.value}>{asset.latest_scan.employee.name || ''} {asset.latest_scan.employee.surname || ''}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>{t('Action:')}</div>
            <div className={styles.value}>{asset.latest_scan.action}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>{t('Project:')}</div>
            <div className={styles.value}>{asset.place ? asset.place.name : '-'}</div>
          </div>
        </div>
      )
    )
  }

  return (
    <div ref={containerRef} className={styles.container}>
      <Map
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${config.google.key}&v=3.exp&language=${i18n.language}`}
        loadingElement={<div style={{ height: `${height}px` }} />}
        containerElement={<div style={{ height: `${height}px` }} />}
        mapElement={<div style={{ height: `${height}px` }} />}
        center={currentCenter}
        zoom={8}>
        {
          assets.filter(asset => asset.latest_scan).map(asset => {
            const [lat, lng] = asset.latest_scan.coordinates.split(',')
            return (
              <OverlayView
                key={asset.id}
                position={{lat: Number(lat), lng: Number(lng)}}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
                <div data-tooltip-id="details" data-tooltip-html={renderTooltipContent(asset)} className={styles.marker}>
                  <LocationIcon />
                </div>
              </OverlayView>
            )
          })
        }
      </Map>
      <ReactTooltip
        variant="light"
        id="details" />
    </div>
  )
}

export default AssetMap
